// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"e394be855e7ad32cadcb","256":"81d25d1fc9a4beae0b84","532":"d5cfba14585dbcc47e17"}[chunkId] + ".js";
};